import * as React from 'react';
import { Error500 } from '~/connect/components';
import { ErrorLayout } from '~/common/components';

interface Props {
  containerStyles?: React.CSSProperties;
}

interface State {
  hasError: boolean;
  error?: undefined | Error;
}

class ErrorBoundary extends React.Component<
  Props & {
    children?: React.ReactNode;
  },
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: undefined };
    this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
  }

  static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  resetErrorBoundary() {
    this.setState({ hasError: false });
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    // eslint-disable-next-line no-console
    console.error(error, errorInfo);
    this.setState((prev) => ({ ...prev, error }));
    // You can also log the error to an error reporting service
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <ErrorLayout>
          <Error500 resetErrorBoundary={this.resetErrorBoundary} />
        </ErrorLayout>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
